/**
 * The getParam util was copied from chord's repo since they might remove it.
 */

const hasURLSearchParams = typeof window !== 'undefined' && typeof URLSearchParams !== 'undefined';

export const getParam = (key) => {
  if (!hasURLSearchParams) return null;
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key);
};

export const hasParam = (key) => {
  if (!hasURLSearchParams) return false;
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(key);
};
